module.exports = __webpack_public_path__ + "static/media/text screenshots a.af681ec2.png";